module.exports = __webpack_public_path__ + "img/staff-icon.7f3d7fd1.svg";